export default {
  title: 'Currency Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Currency code, name, symbol',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    selectFromLibrary: 'Add Currency',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enableItem: 'Enable',
    disableItem: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    code: 'Currency Code',
    nameCn: 'Chinese Name',
    nameEn: 'English Name',
    symbol: 'Symbol',
    decimalPlaces: 'Decimal Places',
    exchangeRateDecimalPlaces: 'Exchange Rate Decimal Places',
    roundingRule: 'Rounding Rule',
    status: 'Status',
    operation: 'Operation'
  },

  // Selection modal
  modal: {
    title: 'Select Currency',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} currencies, {total} available'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this currency?',
    disableItem: 'Are you sure to disable this currency?',
    batchEnable: 'Are you sure to enable the selected {count} currencies?',
    batchDisable: 'Are you sure to disable the selected {count} currencies?'
  },

  // Form validation
  validation: {
    selectItems: 'Please select currencies to add'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select currencies to enable',
    selectToDisable: 'Please select currencies to disable',
    selectToAdd: 'Please select currencies to add',
    loadError: 'Failed to load currency data, please try again later',
    platformLoadError: 'Failed to load platform currency data, please try again later',
    searchError: 'Search failed, please try again later',
    associateError: 'Failed to associate currencies, please try again later',
    associateSuccess: 'Successfully associated {count} currencies',
    statusToggleError: 'Failed to toggle status, please try again later',
    statusToggleSuccess: 'Currency has been {status}',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchEnableSuccess: 'Enabled {count} currencies',
    batchDisableError: 'Failed to batch disable, please try again later',
    batchDisableSuccess: 'Disabled {count} currencies'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // Rounding rules
  roundingRules: {
    halfUp: 'Round Half Up',
    up: 'Round Up',
    down: 'Round Down'
  }
}